import script from "./TelevisionAddonCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TelevisionAddonCard.vue?vue&type=script&lang=ts&setup=true"

import "./TelevisionAddonCard.vue?vue&type=style&index=0&id=4a0443d1&lang=scss"

const __exports__ = script;

export default __exports__